import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { RequestService } from '../../../services/request.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
//import { PagesLayoutComponent } from '../../../layouts/pages-layout/pages-layout.component';

export interface UserData {
    id: string;
    reqId: string;
    requestFor: string;
    subject: string;
    name: string;
    date: string;
    contactLogo: string;
    organization: string;
    status: string;
}

@Component({
  selector: 'app-request-admin-all',
  templateUrl: './request-admin-all.component.html',
  styleUrls: ['./request-admin-all.component.scss']
})
export class RequestAdminAllComponent implements AfterViewInit {
    displayedColumns: string[] = ['reqId', 'requestFor', 'status', 'subject', 'date'];
    dataSource: MatTableDataSource<UserData>;

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;

    requests: Array<UserData> = [];
    loadingMessage: string = "Loading...";

    pagecode: string = "request-admin-all";
    module: string = "request";
    accessdenied: boolean = false;


    constructor( private route: ActivatedRoute, private _router: Router, private requestService: RequestService, private authentication: AuthenticationService, private common: CommonService) {

        this.dataSource = new MatTableDataSource(this.requests);

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {


                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);



                        // load page data
                        this.getAllRequests(1);
                        //

                        window.scroll(0, 0);

                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });


    }

    requestStatus: any = [
        {
            "name": "All",
            "code": "all",
            "isActive": true,
            "active_background_color": "#00a6b6",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "#00a6b6"
        },
        {
            "name": "Open",
            "code": "open",
            "isActive": false,
            "active_background_color": "green",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "green"
        },
        {
            "name": "Closed",
            "code": "closed",
            "isActive": false,
            "active_background_color": "grey",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "grey"
        }
    ];

    applyStatusFilter(statusCode: any) {
        if (statusCode === 'all') {
            this.dataSource = new MatTableDataSource(this.requests);
        }
        else if (statusCode == 'open') {
            var filteredArray: UserData[] = this.requests.filter(s => s.status == 'Open');
            this.dataSource = new MatTableDataSource(filteredArray);
        }
        else if (statusCode == 'closed') {
            var filteredArray: UserData[] = this.requests.filter(s => s.status == 'closed');
            this.dataSource = new MatTableDataSource(filteredArray);
        }

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        for (var i = 0; i < this.requestStatus.length; i++) {
            if (this.requestStatus[i].code === statusCode)
                this.requestStatus[i].isActive = true;
            else
                this.requestStatus[i].isActive = false;
        }

    }

    getAllRequests(page: any) {
        this.requestService.getAllRequests(page).subscribe(
            (res: any) => {

                for (var i = 0; i < res.length; i++) {
                    this.requests.push({
                        id: res[i].id,
                        reqId: res[i].id,
                        requestFor: res[i].requestFor,
                        subject: res[i].subject,
                        name: res[i].fromPortalUser.firstName + ' ' + res[i].fromPortalUser.lastName,
                        date: res[i].createdDate,
                        contactLogo: res[i].fromPortalUser.contactLogo,
                        organization: res[i].fromPortalUser.portalAccount.name,
                        status: res[i].status
                    });
                }
                this.dataSource = new MatTableDataSource(this.requests);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.loadingMessage = "No data found";
                if (res.length > 0)
                    this.getAllRequests(page + 1);
            },
            (err: any) => { }
        );
    }
    clickedRows(row: any) {
        this._router.navigate(['/request/detailad/' + row.id]);
    }
    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
}
///** Builds and returns a new User. */
//function createNewUser(id: number): UserData {
//  const name =
//    NAMES[Math.round(Math.random() * (NAMES.length - 1))] +
//    ' ' +
//    NAMES[Math.round(Math.random() * (NAMES.length - 1))].charAt(0) +
//    '.';

//  return {
//    id: id.toString(),
//    name: name,
//    progress: Math.round(Math.random() * 100).toString(),
//    fruit: FRUITS[Math.round(Math.random() * (FRUITS.length - 1))],
//  };
//}


